import { LayoutDashboard, Smartphone } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { CheckList } from '../compass/shared';

// Section 10 — management and employee experiences, side by side.
export const PulseExperiences = ({ sp }) => (
  <section aria-labelledby="pulse-experiences-heading" data-testid="pulse-experiences" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="10"
        eyebrow="One Platform, Different Views"
        title="Detailed control for management. Simplicity for employees."
        testid="pulse-experiences-header"
      />
      <div className="mt-14 grid gap-6 lg:grid-cols-2">
        <Reveal className="h-full">
          <div className="h-full rounded-xl bg-navy-900 p-7 sm:p-8" data-testid="pulse-experience-management">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gold-500 text-navy-950">
              <LayoutDashboard className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 text-xl font-extrabold tracking-tight text-white">Management</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">
              Full operational and commercial oversight of the workforce.
            </p>
            <div className="mt-6">
              <CheckList items={sp.managementPoints || []} dark testid="pulse-management-points" />
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="h-full">
          <div className="h-full rounded-xl border border-slate-200 bg-white p-7 sm:p-8" data-testid="pulse-experience-employee">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-gold-200 bg-gold-50 text-gold-700">
              <Smartphone className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 text-xl font-extrabold tracking-tight text-navy-900">Employees</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              A straightforward mobile-friendly experience for everyday tasks. Financial and profitability views stay with management.
            </p>
            <div className="mt-6">
              <CheckList items={sp.employeePoints || []} testid="pulse-employee-points" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
